import { useEffect, useState } from "react";
import AnalyticsFilterInputs from "../../../types/analytics/AnalyticsFilterInputs";
import { UsageExplorerManagerRowDto } from "../../../types/analytics/AnalyticsPageDataDto";
import UsageNudgeActionButton from "./UsageNudgeActionButton";
import UsageNudgedAgeLabel from "./UsageNudgedAgeLabel";
import { isUsageNudgeOnCooldown } from "../../../helpers/usage/usageNudgeHelpers";

interface UsageManagerNudgeCellProps {
  row: UsageExplorerManagerRowDto;
  filters: AnalyticsFilterInputs | null;
  lastSentAtOverride?: string | null;
  onSent?: () => void;
}

function UsageManagerNudgeCell({
  row,
  filters,
  lastSentAtOverride,
  onSent,
}: UsageManagerNudgeCellProps) {
  const [lastSentAt, setLastSentAt] = useState(
    lastSentAtOverride ?? row.lastManagerNudgeSentAt ?? null,
  );

  useEffect(() => {
    setLastSentAt(lastSentAtOverride ?? row.lastManagerNudgeSentAt ?? null);
  }, [lastSentAtOverride, row.lastManagerNudgeSentAt, row.managerEmployeeId]);

  if (row.outstandingCount <= 0) {
    return null;
  }

  const isOnCooldown = isUsageNudgeOnCooldown(lastSentAt) && Boolean(lastSentAt);

  return (
    <>
      {isOnCooldown && lastSentAt && (
        <UsageNudgedAgeLabel
          sentAt={lastSentAt}
          senderName={row.lastManagerNudgeSenderName}
        />
      )}
      {/* Kept mounted while on cooldown so a just-sent nudge does not tear down its own modal. */}
      <UsageNudgeActionButton
        filters={filters}
        recipientEmployeeId={row.managerEmployeeId}
        audience="MANAGER"
        recipientName={row.managerName}
        lastSentAt={!isOnCooldown ? lastSentAt : undefined}
        className={isOnCooldown ? "hidden" : undefined}
        onSent={() => {
          setLastSentAt(new Date().toISOString());
          onSent?.();
        }}
      />
    </>
  );
}

export default UsageManagerNudgeCell;
